export const BASE_SPACING = (factor: number) => `${0.25 * factor}rem`; // 4px spacing

export const createSpacing = (scale: number) => (factor: number) => BASE_SPACING(factor * scale);
